<template>
  <PullRefresh
    v-model="refreshLoading"
    success-text="刷新成功"
    @refresh="onRefresh"
    :disabled="dialogVisible || disablePull"
  >
    <div
      class="expand_warp bg_contain"
      :class="{
        light: actInfo.style === 0,
        dark: actInfo.style === 1,
        light2: actInfo.style === 2,
        dark2: actInfo.style === 3,
      }"
      :style="{
        backgroundImage: `url(${actInfo.background})` 
      }"
    >
      <div class="nav">
        <div class="nav_back" @click="handleNativeBack">
          <i class="iconfont yw-xiangzuo" :class="{ color_black: styleIdx === 3 }"></i>
        </div>
        <div class="nav_title" :class="{ color_black: styleIdx === 3 }">{{ actInfo.name }}</div>
        <div class="nav_rule" :class="{ color_black: styleIdx === 3 }" @click="handleGoRule">
          活动规则
        </div>
      </div>
      <template v-if="isGoing">
        <!-- 顶部活动图 -->
        <div
          class="header_bg bg_contain"
          :style="{
            backgroundImage: `url(${actInfo.banner})` 
          }"
        >
        </div>
        <!-- 在玩游戏 & 无推荐游戏 -->
        <div
          v-if="actInfo.collectActivityGameTabList.length && !showRecGame"
          class="playing_games_norec sub_wrap"
        >
          <div
            class="playing_icon"
            :style="{
              backgroundImage: `url(${CDN_URL_1}/box_expandUser/tag.png)` 
            }"
          >
            在玩
          </div>
          <div class="playing_wrap">
            <div
              class="playing_item bg_contain"
              v-for="it in actInfo.collectActivityGameTabList"
              :key="it.gameId"
              :style="{
                backgroundImage: `url(${it.icon})`
              }"
              @click="handleScollTo(it)"
            >
            </div>
          </div>
        </div>
        <!-- 在玩游戏 & 有推荐游戏 -->
        <div
          v-if="actInfo.collectActivityGameTabList.length && showRecGame"
          class="playing_games sub_wrap"
        >
          <div
            class="playing_icon"
            :style="{
              backgroundImage: `url(${imgSrc}/play_${styleIdx}.png)` 
            }"
          >
          </div>
          <div class="playing_wrap">
            <div
              class="playing_item bg_contain"
              v-for="it in [actInfo.collectActivityGameTabList[0]]"
              :key="it.gameId"
              :style="{
                backgroundImage: `url(${it.icon})`
              }"
              @click="handleScollTo(it)"
            >
            </div>
          </div>
        </div>
        <div
          class="main_container"
          @touchstart="disablePull = true"
          @touchend="disablePull = false"
        >
          <div class="games_gifts sub_wrap">
            <div
              class="game_item"
              :class="{
                ['game_pivot_' + game.gameId]: !!game.gameId,
                'game_item_rec': game.recommend === 1 && showRecGame,
              }"
              :style="{
                // backgroundImage: `url(${imgSrc}/${game.recommend === 1 ? 'rec_' : 'normal_'}${styleIdx}.png)`,
              }"
              v-for="(game, gIdx) in gameGiftList"
              :key="game.gameId"
            >
              <div class="game_bg flex_center" style="flex-direction: column;">
                <div
                  :style="{
                    backgroundImage: `url(${imgSrc}/${(game.recommend === 1 && showRecGame) ? 'rec_' : 'normal_'}${styleIdx}_top.png)`,
                  }"
                  class="game_bg_1"
                ></div>
                <div
                  :style="{ backgroundImage: `url(${imgSrc}/rec_${styleIdx}_mid.png)` }"
                  class="game_bg_2 flex_1"
                ></div>
                <div
                  :style="{
                    backgroundImage: `url(${imgSrc}/rec_${styleIdx}_bot.png)`,
                  }"
                  class="game_bg_3"
                ></div>
              </div>
              <div
                class="game_wrap ch_wrap"
                :style="{
                  background: colors[gIdx % 3]
                }"
              >
                <div
                  class="game_img bg_contain"
                  :style="{
                    backgroundImage: `url(${game.icon})`
                  }"
                >
                </div>
                <div class="game_info">
                  <div class="game_title">{{ game.gameName }}</div>
                  <div class="game_desc van-ellipsis">{{ game.price }}</div>
                </div>
                <div
                  class="game_btn btn_game bg_contain"
                  :style="{
                    backgroundImage: `url(${imgSrc}/download_${styleIdx}.png)`
                  }"
                  @click="onSkipDetail(game)"
                ></div>
                <!--  游戏tag -->
                <div v-if="game.content && showRecGame" class="game_tag">
                  <div class="game_tag_bg">
                    <div class="game_tag_bg_item game_tag_bg1"></div>
                    <div class="game_tag_bg_item game_tag_bg2"></div>
                    <div class="game_tag_bg_item game_tag_bg3"></div>
                  </div>
                  <div class="game_tag_content">
                    {{ game.content }}
                  </div>
                </div>
              </div>
              <div class="gifts">
                <div
                  class="gift_wrap ch_wrap"
                  v-for="(gift) in filterGifts(game)"
                  :key="gift.activityGiftId"
                  :style="{
                    background: colors[gIdx % 3]
                  }"
                >
                  <div v-if="gift.tagValue" class="gift_tag">
                    {{ gift.tagValue }}
                  </div>
                  <div
                    class="gift_img bg_contain"
                    :style="{
                      backgroundImage: `url(${gift.giftIcon})`
                    }"
                  >
                  </div>
                  <div class="gift_info">
                    <div class="gift_title">{{ gift.giftName }}</div>
                    <div class="gift_desc van-ellipsis scale09">礼包内容：{{ gift.desc }}</div>
                    <div class="gift_desc van-ellipsis scale09">领取条件：{{ getCondition(gift.drawCondite, gift.condite) }}</div>
                  </div>
                  <div class="gift_right">
                    <div
                      class="gift_btn btn_gift btn_gift_shadow"
                      :class="{ gift_received: gift.drawStatus === 1 }"
                      @click="handleReceive(gift, game)"
                    >
                      {{ gift.drawStatus === 1 ? '已领取' : '领取' }}
                    </div>
                    <div class="gift_receive_status scale09_center">
                      {{ gift.refresh === 1 ? '限领一次' : '每日刷新' }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- 收起与展开 -->
              <div v-if="(game.collectActivityGameGiftVoList || []).length >= 2 && showRecGame && game.recommend === 1" class="game_more flex_center" @click="onExpand(game)">
                <i
                  class="iconfont yw-angle-double-down fs_14"
                  :class="{ transform_180deg: expandGameIds.includes(game.gameId) }"
                ></i>
                <div class="game_more_text ml_6">{{ !expandGameIds.includes(game.gameId) ? "点击查看更多礼包" : "收起" }}</div>
              </div>
            </div>
          </div>
          <div v-if="gameGiftList.length && isWx" class="tip fs_12 text_center">
            <p class="mb_8">温馨提示:</p>
            <p>该活动创角奖励与盒子内其余活动创角奖励不共享</p>
          </div>
        </div>
        <!-- 游戏 & 礼包 -->
      </template>
      <template v-else>
        <div class="notice_wrap">
          {{ actInfo.activityStatus === 2 ? '活动已结束' : `活动将于 ${actInfo.startTime} 开始` }}
        </div>
      </template>
    </div>
    <ActivityDialog
      :title="dialogTitle"
      :visible="dialogVisible"
      hideCancel
      :hideSure="hideConfirmCodes.includes(dialogType)"
      :sureText="sureText"
      @click-sure="onSureDialog"
      @click-cancel="onHideDialog"
      :herderStyle="{ background: '#FFB503' }"
      :sureStyle="{ background: '#FF9916' }"
    >
      <template v-slot:main>
        <div v-if="dialogType" class="dialog">
          <p class="dialog_desc" v-html="conditionText">
          </p>
          <div
            v-if="showProgressCodes.includes(dialogType)"
            class="progress"
          >
            <p class="progress_text">当前进度</p>
            <p
              class="progress_percentage"
              :class="{ left0: percentage === 0 }"
              :style="{ width: percentage + '%' }"
            ></p>
            <p
              v-if="percentage < 100"
              class="amount transformX50"
              :style="{
                left: (percentage === 0 ? 2 : percentage) + '%',
                top: percentage > 90 ? '-22px' : '8px'
              }"
            >
              {{ amount }}
            </p>
            <p
              v-if="percentage < 100"
              class="amount transformX50_1"
              :style="{
                right: 0,
                top: '8px'
              }"
            >
              {{ maxAmount }}
            </p>
          </div>
        </div>
      </template>
    </ActivityDialog>
  </PullRefresh>
</template>

<script>
import ActivityDialog from "@/components/btBox/ActivityDialog";
import {
  setPageTitle,
  jumpToNative,
  clickRightTxt,
  setRightTxtColor,
  setRightTxt,
  callHideToolbar,
  onGoBack,
  toLogin,
  getUserInfo,
  signInEventTrack
} from "@/bridge/AppJsBridge";
import {
  expandUserActivityInfoApi,
  expandUserActivityGiftListApi,
  expandUserActivityDrawGiftApi
} from '@/apis/btBoxActivity'
import { PullRefresh } from "vant";
import { CDN_URL_1 } from "@/config";
import { Toast } from "vant";
import EventTrack from '@/mixins/eventTrack'
import { getSearchParams } from "@/libs/utils";

const colors = [
  'linear-gradient(to bottom, #fffcf5 0%, #fffcd0 100%)',
  'linear-gradient(to bottom, #fffcf5 0%, #f3e6ff 100%)',
  'linear-gradient(to bottom, #fffcf5 0%, #d2fff8 100%)',
]

const StatusEnum = {
  90204 : '未查询到游戏记录',
  90205 : '首次进入该游戏时间不在活动时间范围内',
  90208 : '角色等级不满足条件',
  90209 : '每日付费不满足条件',
  90210 : '活动期间付费不满足条件',
  90211 : '累计登录盒子天数不满足条件',
  90212 : '连续登录盒子天数不满足条件',
}
export default {
  components: {
    PullRefresh,
    ActivityDialog
  },
  mixins: [EventTrack],
  data () {
    return {
      colors,
      CDN_URL_1,
      CDN_URL_2: 'https:' + CDN_URL_1 + '/box_active',
      imgSrc: 'https://assets.hzwxbz2.cn/box/act_center/img',
      refreshLoading: false,
      actInfo: {
        activityStatus: 1, // 活动状态 0-未开始 1-进行中 2-已结束
        startTime: "", // 开始时间 活动未开始会返回
        name: '', // 活动名称
        style: 0, // 0-浅色背景主题 1-深色背景主题 2 3
        background: `${CDN_URL_1}/box_expandUser/bg_light.png`, // 背景图
        banner: '', // 头图
        collectActivityGameTabList: [], // 在玩游戏信息
      },
      gameGiftList: [],
      giftInfo: {}, // 最近领取的礼包信息
      gameInfo: {},
      receiveLoading: false,
      dialogVisible: false,
      disablePull: false,
      dialogTitle: '不满足领取条件',
      sureText: '222',
      dialogType: 1,
      hideConfirmCodes: [90211, 90212],
      showProgressCodes: [90208, 90209, 90210, 90211, 90212], // 需要展示进度条的 codes
      percentage: 40,
      amount: 100,
      maxAmount: 0,
      conditionText: '', // 不满足条件的desc
      expandGameIds: [], // 展开的游戏列表
    }
  },
  beforeRouteEnter: (to, from, next) => {
    callHideToolbar(true)
    next()
  },
  beforeRouteLeave: (to, from, next) => {
    callHideToolbar(false)
    next()
  },
  computed: {
    isWx () {
      // app 0: wx 1: bt
      const app = getSearchParams('app')
      return (app || this.$route.query.app) * 1 !== 1
    },
    // 活动是否进行当中
    isGoing () {
      return this.actInfo.activityStatus === 1
    },
    activityId () {
      return this.$route.query.id
    },
    activityInfo () {
      return {
        activity_id: this.activityId,
        activity_name: this.actInfo.name
      }
    },
    styleIdx () {
      return this.actInfo.style * 1 + 1
    },
    // 是否展示推荐游戏等新样式，不满足则展示老样式
    showRecGame () {
      const { actInfo, gameGiftList } = this
      // const { collectActivityGameTabList } = actInfo
      // const playingIds = collectActivityGameTabList
      //   .filter(v => v.play)
      //   .map(v => v.gameId)
      const recGameIds = gameGiftList
        .filter(v => v.recommend === 1)
        .map(v => v.gameId)
      //  && recGameIds.some(v => !playingIds.includes(v))
      return !!recGameIds.length
    },
  },
  mounted () {
    const { query } = this.$route
    if (query.IS_DEV) {
      this.init()
    }
    this.getAppToken(true)
  },
  methods: {
    init (isFirst) {
      this.fetchInfo().then(() => {
        this.eventTrack({
          event: "lxls_page",
          event_field: JSON.stringify({
            ...this.activityInfo,
          }),
        })
      })
      this.fetchGameGiftList(isFirst)
    },
    onRefresh () {
      this.init()
      setTimeout(() => {
        this.refreshLoading = false
      }, 500)
    },
    handleNativeBack () {
      onGoBack()
    },
    // 获取活动信息
    fetchInfo () {
      return expandUserActivityInfoApi({ activityId: this.activityId }, !this.isWx).then(res => {
        this.actInfo = res.data
      }).catch(err => {
        const { response } = err
        if (response) {
            const { data } = response
            if (data && data.code === 401) {
              toLogin("/loginKey/LoginByKeyPhoneActivity")
            }
          }
      })
    },
    // 获取游戏&礼包列表
    fetchGameGiftList (isFirst) {
      expandUserActivityGiftListApi({ activityId: this.activityId }, !this.isWx).then(res => {
        this.gameGiftList = res.data || []
        if (isFirst) {
          const nofoldGameIds = this.gameGiftList.filter(v => v.giftFold === 2).map(v => v.gameId)
          this.expandGameIds = nofoldGameIds
        }
      })
    },
    getCondition (type, value) {
      const map = {
        0: '活动期间注册游戏可领',
        1: `活动期间创角并达${value}级可领`,
        2: `今日充值${value}元可领`,
        3: `活动期间充值${value}可领`,
        4: `累计登录盒子${value}天可领`,
        5: `连续登录盒子${value}天可领`,
      }
      return map[type]
    },
    handleReceive (gift, game) {
      if (this.receiveLoading || gift.drawStatus === 1) return
      this.eventTrack({
        event: "lxls_draw_button",
        event_field: JSON.stringify({
          ...this.activityInfo,
          gift_id: gift.giftId,
          gift_name: gift.giftName,
          type: gift.drawCondite
        }),
        appkey: game.gameId,
        appName: game.gameName,
      })
      this.receiveLoading = true
      this.giftInfo = gift
      this.gameInfo = {
        gameId: game.gameId,
        gameName: game.gameName,
      }
      expandUserActivityDrawGiftApi({
        activityGiftId: gift.activityGiftId
      }, !this.isWx)
        .then(res => {
          const { cdk } = res.data
          if (cdk === null) {
            // 礼包码为null时表示生成错误
            this.openDialog(-1, '1/1')
          } else {
            this.openDialog(1, '1/1')
          }
          // EVENT_TRACK_5/7
          this.eventTrack({
            event: "lxls_draw_success_pop",
            event_field: JSON.stringify({
              ...this.activityInfo,
              gift_id: gift.giftId,
              gift_name: gift.giftName,
              type: gift.drawCondite,
              pop_type: cdk === null ? 1 : 0
            }),
            appkey: game.gameId,
            appName: game.gameName,
          })
          this.fetchGameGiftList()
        })
        .catch((e) => {
          const codes = Object.keys(StatusEnum).map(v => v * 1)
          if (!codes.includes(e.code)) {
            Toast.fail({
              message: e.msg || e.message,
              duration: 2000,
            });
          } else {
            this.openDialog(e.code, e.msg)
          }
          console.log(e)
        })
        .finally(() => {
          this.receiveLoading = false
        })
      // EVENT_TRACK_4
    },
    // code 相关值
    openDialog (type, val = '') {
      this.dialogVisible = true
      this.dialogType = type
      const [present, target] = val.split('/')
      this.dialogTitle = "不满足领取条件"
      if (this.showProgressCodes.includes(type)) {
        this.percentage = present / target * 100
        this.amount = present
        this.maxAmount = target
        this.eventTrack({
          event: "lxls_draw_faile_pop_condit",
          event_field: JSON.stringify({
            ...this.activityInfo,
            gift_id: this.giftInfo.giftId,
            gift_name: this.giftInfo.giftName,
            type: this.giftInfo.drawCondite,
            current: present,
            target,
          }),
          appkey: this.gameInfo.gameId,
          appName: this.gameInfo.gameName,
        })
      }
      if (type === 90211) {
        this.sureText = "我知道了"
        this.conditionText = `活动期间累计登录盒子达${target}天
          即可领取礼包`
      }
      if (type === 90212) {
        this.sureText = "我知道了"
        this.conditionText = `活动期间连续登录盒子达${target}天
          即可领取礼包`
      }
      if (type === 90204) {
        this.sureText = "下载游戏"
        this.conditionText = `未查询到游戏记录
          在活动时间内下载游戏并用此账号创角即可领取礼包`
      }
      if (type === 90205) {
        this.sureText = "我知道了"
        this.conditionText = `您首次进入该游戏时间
          不在活动时间范围内
          无法领取礼包`
      }
      if (type === 90208) {
        this.sureText = "去完成"
        this.conditionText = `角色达${target}级
          即可领取礼包`
      }
      if (type === 90209) {
        this.sureText = "去完成"
        this.conditionText = `今日在游戏内充值金额达到${target}元即可领取礼包`
      }
      if (type === 90210) {
        this.sureText = "去完成"
        this.conditionText = `活动期间充值金额达到${target}
          即可领取礼包`
      }
      if (type === 1) {
        this.dialogTitle = "领取成功"
        this.sureText = '查看礼包码'
        this.conditionText = `礼包已存放在
        【我的】-【我的礼包】-【活动礼包】`
      }
      if (type === -1) {
        this.dialogTitle = "提示"
        this.sureText = '联系客服'
        this.conditionText = `兑换码生成错误，请联系客服领取备用码`
      }
      if ([90204, 90205].includes(type)) {
        this.eventTrack({
          event: "lxls_draw_faile_pop",
          event_field: JSON.stringify({
            ...this.activityInfo,
            gift_id: this.giftInfo.giftId,
            gift_name: this.giftInfo.giftName,
            type: this.giftInfo.drawCondite,
          }),
          appkey: this.gameInfo.gameId,
          appName: this.gameInfo.gameName,
        })
      }
    },
    onSureDialog () {
      const code = this.dialogType
      if ([90204, 90208, 90209, 90210].includes(code)) {
        console.log('给我去下载游戏')
        this.onSkipDetail({ gameId: this.gameInfo.gameId }, true)
      }
      if ([90205].includes(code)) {
        this.onHideDialog()
      }
      if ([1, -1].includes(code)) {
        this.eventTrack({
          event: "lxls_draw_success_pop_button",
          event_field: JSON.stringify({
            ...this.activityInfo,
            gift_id: this.giftInfo.giftId,
            gift_name: this.giftInfo.giftName,
            type: this.giftInfo.drawCondite,
            button_type: code === 1 ? 0 : 1
          }),
          appkey: this.gameInfo.gameId,
          appName: this.gameInfo.gameName,
        })
        // 用 1 表示没有错误码
        if (code === 1) {
          this.onClickGiftCdk()
        }
        if (code === -1) {
          this.onRelationServer()
        }

      }
      if ([90204].includes(code)) {
        this.eventTrack({
          event: "lxls_draw_faile_pop_button",
          event_field: JSON.stringify({
            ...this.activityInfo,
            gift_id: this.giftInfo.giftId,
            gift_name: this.giftInfo.giftName,
            type: this.giftInfo.drawCondite
          }),
          appkey: this.gameInfo.gameId,
          appName: this.gameInfo.gameName,
        })
      }
      if ([90208, 90209, 90210].includes(code)) {
        this.eventTrack({
          event: "lxls_draw_faile_pop_to_complete_button",
          event_field: JSON.stringify({
            ...this.activityInfo,
            gift_id: this.giftInfo.giftId,
            gift_name: this.giftInfo.giftName,
            type: this.giftInfo.drawCondite,
            current: this.amount,
            target: this.maxAmount
          }),
          appkey: this.gameInfo.gameId,
          appName: this.gameInfo.gameName,
        })
      }
      this.onHideDialog()
    },
    onHideDialog () {
      this.dialogVisible = false;
    },
    // 跳转礼包
    onClickGiftCdk() {
      const data = {
        routePath: "/gift/MineGiftActivity",
        extraParams: this.isWx ? 3 : 2, // 2 -> BT盒子活动 3-> 玩心盒子活动
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr)
      this.onHideDialog()
    },
    // 联系客服
    onRelationServer() {
      this.$router.push({
        name: `box.customerService`,
      });
    },
    // 游戏详情 
    onSkipDetail(it, isPop = false){
      if (!isPop) {
        this.eventTrack({
          event: "lxls_download_button",
          event_field: JSON.stringify({
            ...this.activityInfo,
          }),
          appkey: it.gameId,
          appName: it.gameName,
        })
      }
      const data = {
        routePath: "/main/game/GameDetailActivity",
        fromPageType: this.isWx ? 40 : 34,
        extraParams: it.gameId
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },
    handleGoRule () {
      this.eventTrack({
        event: "lxls_rule_button",
        event_field: JSON.stringify({
          ...this.activityInfo,
        }),
      })
      this.$router.push({
        name: this.isWx ? `box.actPlaceRule` : `box.btActRule`,
        params: {
          type: this.isWx ? 30 : 12,
        },
      });
    },
    // 点击在玩游戏 icon，滚动到
    handleScollTo (it) {
      const ele = document.querySelector('.game_pivot_' + it.gameId)
      if (!ele) return
      // EVENT_TRACK_2
      this.eventTrack({
        event: "lxls_play_game_tab",
        event_field: JSON.stringify({
          ...this.activityInfo,
        }),
        appkey: it.gameId,
        appName: it.gameName,
      })
      ele.scrollIntoView({
        top: 10,
        left: 0,
        behavior: "smooth"
      })
    },
    getActivityInfo () {
      this.init(true)
    },
    onExpand (game) {
      const { gameId } = game || {}
      if (this.expandGameIds.includes(gameId)) {
        this.expandGameIds = this.expandGameIds.filter(i => i !== gameId)
      } else {
        this.expandGameIds.push(gameId)
      }
    },
    filterGifts (game) {
      const { collectActivityGameGiftVoList, gameId, recommend } = game
      if (this.expandGameIds.includes(gameId) || !this.showRecGame || recommend === 2) {
        return collectActivityGameGiftVoList
      } else {
        return collectActivityGameGiftVoList.slice(0, 2)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
